import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useEventsStore} from "../../store/events.store";

export const useEvents = () => {
    const setEvents = useEventsStore((state) => state.setEvents);

    return useMutation(PartnerApi.events, {
        onSuccess: (data) => {
            setEvents(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};